import PasswordResetForm from '../components/Password/PasswordResetForm';

export default function PasswordReset() {
  return (
    <div>
      <PasswordResetForm />
    </div>
  );
}
